import { GetBonusAccountTransactionsResponseV1 } from 'api/version1';
import clsx from 'clsx';
import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';

import { IMG_PLACEHOLDER_BONUS } from 'images';
import { $language } from 'domains/language';

import { Transaction } from './components';

import style from './style.module.css';

const Content = ({
  transactions,
  showInfo,
  onChangeShowInfo,
}: {
  showInfo: boolean;
  onChangeShowInfo: (v: boolean) => void;
  transactions: GetBonusAccountTransactionsResponseV1.ResponseItem[];
}) => {
  const { t } = useTranslation();
  const language = useUnit($language);

  const validDate = (date: string) => {
    return moment(date).locale(language).format('DD.MM.YYYY');
  };

  const filteredTransactions = React.useMemo(() => {
    return transactions.filter((transaction) => {
      return transaction.type !== 'STATUS_CHANGED';
    });
  }, [transactions]);

  return (
    <>
      

      {showInfo ? (
        <div className={style.info}>
          <div className={style.infoContainer}>
            <img
              className={style.infoIcon}
              src={IMG_PLACEHOLDER_BONUS}
              alt=''
            />

            <div className={style.infoContent}>
              <p className={clsx('title', style.infoTitle)}>
                {t('bonus.page.info.title')}
              </p>

              <p className={clsx('text-2', style.infoMessage)}>
                {t('bonus.page.info.message.1')}
                <br />
                {t('bonus.page.info.message.2')}
                <br />
                <br />
                {t('bonus.page.info.message.3')}
                <br />
                {t('bonus.page.info.message.4')}
                <br />
                {t('bonus.page.info.message.5')}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className={style.transactions}>
          {!!filteredTransactions.length ? (
            filteredTransactions.map((transaction) => (
              <Transaction
                key={`${transaction.orderId}-${transaction.createdAt}`}
                transaction={transaction}
                date={validDate(transaction.createdAt)}
              />
            ))
          ) : (
            <div className={style.noTransactionsContainer}>
              <p className={clsx('text-2', style.noTransactionsMessage)}>
                {t('bonus.page.noTransactionsLabel')}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Content;